import { render, staticRenderFns } from "./SchoolDynamics.vue?vue&type=template&id=7620f1ac&scoped=true"
import script from "./SchoolDynamics.vue?vue&type=script&lang=js"
export * from "./SchoolDynamics.vue?vue&type=script&lang=js"
import style0 from "./SchoolDynamics.vue?vue&type=style&index=0&id=7620f1ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7620f1ac",
  null
  
)

export default component.exports